/**
 * Directive implements sticky header behavior
 * with auto-hiding on scrolling a page down
 *
 * <div gw-pl-sticky-header class="header-sticky"></div>
 *
 */
define([
    // https://github.com/eduardomb/scroll-up-bar
    'bower_components/scroll-up-bar/dist/scroll-up-bar'
], ()=> {
    return ['phoneMediaBreakpoint', (phoneMediaBreakpoint)=> {
        return {
            'restrict': 'A',
            'link': ($scope, element)=> {
                /*--- VARS ---*/
                const mediaQuery = window.matchMedia(`(max-width: ${phoneMediaBreakpoint}px)`);

                /*--- METHODS ---*/

                // APPLY "FIXED" HEADER ONLY FOR MOBILE DEVICES
                // media query change
                function breakpointReached(_mediaQuery) {
                    if (_mediaQuery.matches) {// < break
                        element.scrollupbar({
                            exitViewport: ()=> {
                                $scope.$emit('stickyHeaderExitViewport');
                                angularApply();
                            }
                        });
                    } else {// >= break
                        resetToDefault();
                    }
                }

                function resetToDefault() {
                    $.scrollupbar.destroy();

                    element.css({
                        'position': '',
                        'top': ''
                    });
                }

                // has to be invoked when some functionality is called outside of AngularJs
                function angularApply() {
                    if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                        $scope.$apply();
                    }
                }

                // INIT
                breakpointReached(mediaQuery);

                // EVENTS
                mediaQuery.addListener(breakpointReached);

                // remove listeners on $scope destroying
                $scope.$on('$destroy', ()=> {
                    mediaQuery.removeListener(breakpointReached);
                    resetToDefault();
                });
            }
        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/pagestructure/directives/StickyHeaderDirective.js
 **/